import React, { PropsWithChildren } from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import Footer from '../shared/Footer';

const drawerWidth = 240;

const Layout: React.FC<PropsWithChildren> = ({ children }) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <Navbar />
            <Sidebar />
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    p: 3,
                    pt: 10,
                    
                    marginLeft: `${drawerWidth}px`,
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: `calc(100vh - 64px)` // Subtract navbar height
                }}
            >
                {children || <Outlet />}
                <Footer variant="admin" />
            </Box>
        </Box>
    );
};

export default Layout;
